/* src/app/common/components/share-option/share-option.component.scss */
.smartdine-form {
  padding: 12px;
}
.smartdine-form ion-item {
  --background: #fbfefc;
  border-radius: 8px;
  margin-bottom: 8px;
  --inner-padding-end: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.smartdine-form ion-item ion-label {
  min-width: 120px;
  font-weight: 600;
  color: var(--ion-color-primary);
  font-size: 14px;
}
.smartdine-form ion-item ion-input,
.smartdine-form ion-item ion-select {
  text-align: right;
}
.smartdine-form .required-star {
  color: var(--ion-color-danger);
  margin-left: 4px;
}
.smartdine-form small.error-text {
  color: var(--ion-color-danger);
  display: block;
  text-align: right;
  font-size: 12px;
  padding: 2px 4px 6px;
}
/*# sourceMappingURL=share-option.component.css.map */
